import constants from "./constants";
import { haveValue } from "../helper/common";

// Ownership of an uploaded tenant document: who uploaded it, and whether it
// belongs to someone other than the profile owner. Used for the row badges,
// owner labels, and third-party row styling (delete action, borders).

// "Other" is a placeholder owner value, not a separate document owner.
export const normalizeComparableName = (value) =>
  (value ?? "").toString().trim().toLowerCase().replace(/\s+/g, " ");

export const getDocOwnerLabel = (doc) => {
  return doc?.analysisOwnerName || doc?.uploadedFor || "";
};

// True when the document belongs to someone other than the profile owner.
// A legal entity is always a third party, even when its profile is marked
// as the uploader. Only falls back to the uploader/name checks otherwise.
export const isDocOwnedByOtherPerson = (doc, profileName) => {
  if (!doc) return false;
  const ownerLabel = getDocOwnerLabel(doc);
  const normalizedOwnerLabel = normalizeComparableName(ownerLabel);

  if (normalizedOwnerLabel === constants.OTHER) return false;

  if (doc?.analysisOwnerType === "legal_entity") return true;
  if (doc?.analysisIsUploader === true) return false;
  if (doc?.analysisIsUploader === false) return true;

  if (!haveValue(ownerLabel)) return false;

  return normalizedOwnerLabel !== normalizeComparableName(profileName);
};
